<div class="pill {{ color() }}">
  <ng-content />
</div>
